import { Ref, computed } from 'vue';

import { NIssue } from 'SharedDir/declarations/issue';

export function useIssueFileAccess(issue: Ref<NIssue.IssueWithHistory | null>) {
  const fileAccess = computed(() => ({
    // Файл доступен авторизованным пользователям
    PRIVATE: {
      isPublic: false,
      authorizedOnly: true,
      userProfileId: issue.value?.userProfileId ?? null,
    },
  }));

  return {
    fileAccess,
  };
}
